goog.provide("shadow.js.shim.module$spark_md5$default");
shadow.js.shim.module$spark_md5$default = shadow.js.shim.module$spark_md5.default;
